// extracted by mini-css-extract-plugin
module.exports = {"contentPadding":"dashboard-layout_contentPadding__gxX_v"};